module.exports = __webpack_public_path__ + "static/media/1POLICY46.eff0ff30.jpg";